export default __webpack_public_path__ + "static/media/Simon_Carrier_Resume.15d9235b.pdf";